<template>
    <div
        :class="[
            {
                veil: !isAiModal,
                'is-ai-modal': isAiModal,
            },
        ]"
    >
        <div class="underlay" />

        <div class="spinner">
            <div class="dot1" />
            <div class="dot2" />
        </div>
    </div>
</template>

<style lang="scss">
    @import '../../style/variables';

    .veil {
        position: absolute;
        z-index: 100;
        text-align: center;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    .veil .underlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0.5;
        background-color: #111;
    }

    .spinner {
        width: 80px;
        height: 80px;
        text-align: center;
        animation: sk-rotate 2s infinite linear;
        position: fixed;
        top: 50%;
        left: 50%;
        margin-top: -40px;
        margin-left: -40px;
    }

    .dot1,
    .dot2 {
        width: 60%;
        height: 60%;
        display: inline-block;
        position: absolute;
        top: 0;
        background-color: #fff;
        border-radius: 100%;
        animation: sk-bounce 2s infinite ease-in-out;
    }

    .dot2 {
        top: auto;
        bottom: 0;
        animation-delay: -1s;
    }

    .is-ai-modal {
        .spinner {
            width: 96px;
            height: 96px;
            margin-top: -48px;
            margin-left: -48px;
        }

        .dot1,
        .dot2 {
            background-color: color(v2BlueMedium);
        }
    }

    @keyframes sk-rotate {
        100% {
            transform: rotate(360deg);
        }
    }

    @keyframes sk-bounce {
        0%,
        100% {
            transform: scale(0);
        }

        50% {
            transform: scale(1);
        }
    }
</style>

<script>
    export default {
        props: {
            isAiModal: {
                type: Boolean,
                default: false,
            },
        },
    };
</script>
